export const BONIFICO_ORDERS_LIST_PATH = "/admin/bonifico/all-orders";

export function toBonificoOrdersSearchPath(search: string): string {
  return `${BONIFICO_ORDERS_LIST_PATH}?search=${encodeURIComponent(search)}`;
}
